import {
  EuiButton,
  EuiButtonIcon,
  EuiCopy,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFormRow,
  EuiLink,
  EuiModal,
  EuiModalBody,
  EuiModalHeader,
  EuiText,
  EuiModalHeaderTitle,
  EuiModalFooter,
} from "@elastic/eui";
import { Plan, PlanStatus } from "../../api/entities/Plan";
import { FC, useState } from "react";
import {
  useCreateESignTokenMutation,
  useSendESignLinkMutation,
} from "../../api/rtkQueryApi/AgreementsApi";
import moment from "moment";
import { PlanStartDatePicker } from "../time/PlanStartDatePicker";
import { useUpdatePlanStartDateMutation } from "../../api/rtkQueryApi/PlansApi";
import { Business } from "api/entities/Business";

export interface IESignLink {
  business: Business;
  plan: Plan;
}

export const ESignTokenGenerator: FC<IESignLink> = (props) => {
  const [sendESignLink, sendESignLinkRequest] = useSendESignLinkMutation();
  const [generateESignToken, generateESignTokenRequest] =
    useCreateESignTokenMutation();
  const [updateStartDate, updateStartDateRequest] =
    useUpdatePlanStartDateMutation();
  const [newStartDate, setNewStartDate] = useState<string>(
    moment().format("MM/DD/YYYY"),
  );

  const [remotePurchaseLink, setRemotePurchaseLink] = useState<string>();
  const [showRemotePurchaseLink, setShowRemotePurchaseLink] = useState(false);

  const [showUpdateStartDate, setShowUpdateStartDate] = useState(false);

  const getRemotePurchaseLink = () => {
    if (
      props.plan.activeAgreementId &&
      props.plan.status === PlanStatus.PendingSignature
    ) {
      generateESignToken({
        agreementId: props.plan.activeAgreementId,
      }).then((result) => {
        const url = window.location.origin + "/signDocument/" + result.data;
        setRemotePurchaseLink(url);
        setShowRemotePurchaseLink(true);
      });
    }
  };

  const sendRemotePurchaseLink = async () => {
    if (
      props.plan.activeAgreementId &&
      props.plan.status === PlanStatus.PendingSignature
    ) {
      const result = await generateESignToken({
        agreementId: props.plan.activeAgreementId,
      });

      const url = window.location.origin + "/signDocument/" + result.data;
      setRemotePurchaseLink(url);
      setShowRemotePurchaseLink(true);
      await sendESignLink({
        agreementId: props.plan.activeAgreementId,
        email: props.business.email,
        eSignLink: url,
      });

      closeModal();
    }
  };

  const updateStartDateClick = () => {
    setShowUpdateStartDate(true);
  };

  const onConfirmUpdateStartDate = () => {
    updateStartDate({
      planId: props.plan.id,
      startDate: newStartDate,
    }).then(() => {
      setShowUpdateStartDate(false);
    });
  };

  const closeModal = () => {
    setShowRemotePurchaseLink(false);
    setRemotePurchaseLink("");
  };

  return (
    <>
      {moment(props.plan.schedule.eventStartDate).isBefore(
        moment().startOf("day"),
      ) ? (
        <EuiLink onClick={updateStartDateClick}>
          <EuiText size={"xs"}>Update Start Date</EuiText>
        </EuiLink>
      ) : (
        <EuiLink onClick={getRemotePurchaseLink}>
          <EuiText size={"xs"}>Generate E-Sign Link</EuiText>
        </EuiLink>
      )}
      {showUpdateStartDate && (
        <EuiModal
          onClose={() => {
            setShowUpdateStartDate(false);
          }}
        >
          <EuiModalBody>
            <EuiFormRow>
              <PlanStartDatePicker
                onSelectedDateChange={setNewStartDate}
                selectedDate={newStartDate}
              />
            </EuiFormRow>
            <EuiFormRow>
              <EuiButton
                onClick={onConfirmUpdateStartDate}
                isLoading={updateStartDateRequest.isLoading}
              >
                Update
              </EuiButton>
            </EuiFormRow>
          </EuiModalBody>
        </EuiModal>
      )}
      {showRemotePurchaseLink && remotePurchaseLink && (
        <EuiModal onClose={closeModal}>
          <EuiModalHeader>
            <EuiModalHeaderTitle size={"s"}>E-Sign</EuiModalHeaderTitle>
          </EuiModalHeader>
          <EuiModalBody>
            <EuiFormRow fullWidth>
              <EuiCopy textToCopy={remotePurchaseLink}>
                {(copy) => (
                  <EuiFlexGroup>
                    <EuiFlexItem grow={false}>
                      <EuiText size={"s"}>{remotePurchaseLink}</EuiText>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                      <EuiButtonIcon onClick={copy} iconType={"copy"} />
                    </EuiFlexItem>
                  </EuiFlexGroup>
                )}
              </EuiCopy>
            </EuiFormRow>
          </EuiModalBody>
          <EuiModalFooter>
            <EuiFlexGroup>
              <EuiFlexItem>
                <EuiButton
                  onClick={getRemotePurchaseLink}
                  isLoading={generateESignTokenRequest.isLoading}
                  isDisabled={
                    generateESignTokenRequest.isLoading ||
                    sendESignLinkRequest.isLoading
                  }
                >
                  Regenerate E-Sign Link
                </EuiButton>
              </EuiFlexItem>
              <EuiFlexItem>
                <EuiButton
                  fill={true}
                  onClick={sendRemotePurchaseLink}
                  isLoading={sendESignLinkRequest.isLoading}
                  isDisabled={
                    generateESignTokenRequest.isLoading ||
                    sendESignLinkRequest.isLoading
                  }
                >
                  Send E-Sign Link to {props.business.email}
                </EuiButton>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiModalFooter>
        </EuiModal>
      )}
    </>
  );
};
